import { render, staticRenderFns } from "./TableInativacaoLotePreview.vue?vue&type=template&id=382a7f37&scoped=true&"
import script from "./TableInativacaoLotePreview.vue?vue&type=script&lang=js&"
export * from "./TableInativacaoLotePreview.vue?vue&type=script&lang=js&"
import style0 from "./TableInativacaoLotePreview.vue?vue&type=style&index=0&id=382a7f37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a7f37",
  null
  
)

export default component.exports